module.exports = __webpack_public_path__ + "img/twitter-white.1092570c.png";